<mat-toolbar color="primary">
  <img
    [routerLink]="home$ | async"
    src="/assets/img/glimpse-logo.png"
    srcset="/assets/img/glimpse-logo.png, /assets/img/glimpse-logo@2x.png 2x"
    alt="Glimpse logo"
    role="navigation"
    class="company-logo"
    />

    @if (user$ | async; as user) {
      @if (isAdminPage$ | async) {
        <span class="hide-gt-md">
          <button mat-icon-button aria-label="Open Sidebar" (click)="toggleSidebarAdmin()">
            <mat-icon>menu</mat-icon>
          </button>
          Administration
        </span>
      }
      @if (isAuditingPage$ | async) {
        <span class="hide-gt-md">
          <button mat-icon-button aria-label="Open Sidebar" (click)="toggleSidebarAuditing()">
            <mat-icon>menu</mat-icon>
          </button>
          Auditing
        </span>
      }
    }

    <div style="flex: 1 1 auto;"></div>

    @if (user$ | async; as user) {
      <app-user-menu
        [user]="user"
        (logout)="logout()"
        [isAdmin]="isAdmin$ | async"
        [isInAdmin]="isAdminPage$ | async"
        [isInAuditing]="isAuditingPage$ | async"
      ></app-user-menu>
    }
  </mat-toolbar>
